module.exports = __webpack_public_path__ + "img/2_23.d3e31303.png";